module.exports = "/assets/data/bff03d9877eb3044b1b91d06adf00c96-LU5.data.json";